/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PerplayStatisticsControllerDtoNftCarStatisticsNftCarData model module.
 * @module model/PerplayStatisticsControllerDtoNftCarStatisticsNftCarData
 * @version 1.0
 */
class PerplayStatisticsControllerDtoNftCarStatisticsNftCarData {
    /**
     * Constructs a new <code>PerplayStatisticsControllerDtoNftCarStatisticsNftCarData</code>.
     * @alias module:model/PerplayStatisticsControllerDtoNftCarStatisticsNftCarData
     */
    constructor() { 
        
        PerplayStatisticsControllerDtoNftCarStatisticsNftCarData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PerplayStatisticsControllerDtoNftCarStatisticsNftCarData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PerplayStatisticsControllerDtoNftCarStatisticsNftCarData} obj Optional instance to populate.
     * @return {module:model/PerplayStatisticsControllerDtoNftCarStatisticsNftCarData} The populated <code>PerplayStatisticsControllerDtoNftCarStatisticsNftCarData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PerplayStatisticsControllerDtoNftCarStatisticsNftCarData();

            if (data.hasOwnProperty('targetDate')) {
                obj['targetDate'] = ApiClient.convertToType(data['targetDate'], 'Date');
            }
            if (data.hasOwnProperty('totalIssuedCount')) {
                obj['totalIssuedCount'] = ApiClient.convertToType(data['totalIssuedCount'], 'Number');
            }
            if (data.hasOwnProperty('totalSpendingCount')) {
                obj['totalSpendingCount'] = ApiClient.convertToType(data['totalSpendingCount'], 'Number');
            }
            if (data.hasOwnProperty('totalHolderCount')) {
                obj['totalHolderCount'] = ApiClient.convertToType(data['totalHolderCount'], 'Number');
            }
            if (data.hasOwnProperty('walletToSpendingCount')) {
                obj['walletToSpendingCount'] = ApiClient.convertToType(data['walletToSpendingCount'], 'Number');
            }
            if (data.hasOwnProperty('spendingToWalletCount')) {
                obj['spendingToWalletCount'] = ApiClient.convertToType(data['spendingToWalletCount'], 'Number');
            }
            if (data.hasOwnProperty('breedingCount')) {
                obj['breedingCount'] = ApiClient.convertToType(data['breedingCount'], 'Number');
            }
            if (data.hasOwnProperty('evolveCount')) {
                obj['evolveCount'] = ApiClient.convertToType(data['evolveCount'], 'Number');
            }
            if (data.hasOwnProperty('evolveBurnCount')) {
                obj['evolveBurnCount'] = ApiClient.convertToType(data['evolveBurnCount'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PerplayStatisticsControllerDtoNftCarStatisticsNftCarData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PerplayStatisticsControllerDtoNftCarStatisticsNftCarData</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Date} targetDate
 */
PerplayStatisticsControllerDtoNftCarStatisticsNftCarData.prototype['targetDate'] = undefined;

/**
 * @member {Number} totalIssuedCount
 */
PerplayStatisticsControllerDtoNftCarStatisticsNftCarData.prototype['totalIssuedCount'] = undefined;

/**
 * @member {Number} totalSpendingCount
 */
PerplayStatisticsControllerDtoNftCarStatisticsNftCarData.prototype['totalSpendingCount'] = undefined;

/**
 * @member {Number} totalHolderCount
 */
PerplayStatisticsControllerDtoNftCarStatisticsNftCarData.prototype['totalHolderCount'] = undefined;

/**
 * @member {Number} walletToSpendingCount
 */
PerplayStatisticsControllerDtoNftCarStatisticsNftCarData.prototype['walletToSpendingCount'] = undefined;

/**
 * @member {Number} spendingToWalletCount
 */
PerplayStatisticsControllerDtoNftCarStatisticsNftCarData.prototype['spendingToWalletCount'] = undefined;

/**
 * @member {Number} breedingCount
 */
PerplayStatisticsControllerDtoNftCarStatisticsNftCarData.prototype['breedingCount'] = undefined;

/**
 * @member {Number} evolveCount
 */
PerplayStatisticsControllerDtoNftCarStatisticsNftCarData.prototype['evolveCount'] = undefined;

/**
 * @member {Number} evolveBurnCount
 */
PerplayStatisticsControllerDtoNftCarStatisticsNftCarData.prototype['evolveBurnCount'] = undefined;






export default PerplayStatisticsControllerDtoNftCarStatisticsNftCarData;

